import { makeApiRequest } from './helpers.js';
import { API_URL } from '../api-config.js';
import axios from "axios"


Date.prototype.getUnixTime = function() {
    return this.getTime()/1000|0
};

if(!Date.now) {
    Date.now = function() {
        return new Date();
    };
}

Date.time = function() {
    return Date.now().getUnixTime();
};

const configurationData = {
    supportedResolutions: ['1D'],
    
};

const lastLoadedTime = {};
const activeSubscribers = {};
let lastSentBars = {};
let lastBarTime = 0;
const dailyDatafeed = {
    onReady: cb => {
        console.log('=====onReady running')	
        setTimeout(() => cb(configurationData), 0)
    },
    
    resolveSymbol: (_symbolName, onSymbolResolvedCallback, ) => {
        console.log('======resolveSymbol running')
        var symbol_stub = {
            name: 'USDCLP',
            description: 'USD/CLP by QRT Solutions',
            type: 'forex',
            session: '0700-2000',
            timezone: 'America/Santiago',
            exchange: '',
            minmov: 2,
            pricescale: 100,
            has_intraday: true,
            visible_plots_set: 'ohlc',
            has_weekly_and_monthly: false,
            supported_resolutions: configurationData.supportedResolutions,
            volume_precision: 2,
            data_status: 'streaming',
        }

        setTimeout(function() {
            onSymbolResolvedCallback(symbol_stub)
            console.log('Resolving that symbol....', symbol_stub)
        }, 0)
    },

    subscribeBars: (
        _symbolInfo,
        _resolution,
        onRealtimeCallback,
        subscriberUID,
    ) => {
        setTimeout(() => {
            console.log('[subscribeBars]: Method call with subscriberUID:', subscriberUID);
            if (!lastLoadedTime[subscriberUID]) {
                lastLoadedTime[subscriberUID] = 0;
            }
            const intervalId = setInterval(async () => {
                try {
                    const data = await makeApiRequest(`${API_URL}/last_100_ticks`);
                    // let data;

                    if (data) {
                        const bars = data.map(bar => ({
                            // Sumar 4 horas a la fecha (4 horas * 60 minutos * 60 segundos * 1000 milisegundos)
                            time: (new Date(bar.Datetime)).getTime() + 4 * 60 * 60 * 1000,
                            low: bar.Low,
                            high: bar.High,
                            open: bar.Open,
                            close: bar.Close,
                            volume: bar.Volume,
                        })).sort((a, b) => a.time - b.time);
                        
                        const newBars = bars.filter(bar => bar.time > lastLoadedTime[subscriberUID] && bar.time > lastBarTime);
                        if (newBars.length > 0) {
                            newBars.forEach(bar => {
                                onRealtimeCallback(bar);
                            });
                            lastLoadedTime[subscriberUID] = newBars[newBars.length - 1].time;
                        }
                    } else {
                        console.error('La respuesta no contiene la propiedad "result"');
                    }
                } catch (error) {
                    console.error('Error updating bars:', error);
                }
            }, 60000);
            activeSubscribers[subscriberUID] = intervalId;
        }, 10000);
    },

    unsubscribeBars: (subscriberUID) => {
        console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
        clearInterval(activeSubscribers[subscriberUID]);
        delete activeSubscribers[subscriberUID];
    },

    getBars: async(symbolInfo, resolution, _periodParams, onHistoryCallback, onErrorCallback) =>{
        try{
            const token = localStorage.getItem("token");
            let data_init;
            await axios.get(`${API_URL}/trading-api/historical/daily/1000`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            ).then((response) => {
                data_init = response.data;
                console.log(data_init)
            })
            // const data_init = await makeApiRequest(`${API_URL}/trading-api/daily/1000`);
            const bars = await data_init.map((bar, ) => {
                const currentTime = (new Date(bar.date)).getTime();
                return {
                    time: currentTime,
                    low: bar.low,
                    high: bar.high,
                    open: bar.open_price,
                    close: bar.close,
                    volume: bar.volume,
                    
                };
            });
            var b = bars.reverse();
            if(data_init.length < 1){
                onHistoryCallback([], { noData: true });
            } else {
                onHistoryCallback(b, { noData: false });
            }
            const subscriberUID = `${symbolInfo.ticker}_#_${resolution}`;
            if (bars.length > 0) {
                lastBarTime = bars[bars.length - 1].time;
                lastSentBars[subscriberUID] = bars[bars.length - 1];
            }

        } catch (error) {
            console.log('[getBars]: Get error', error);
            onErrorCallback(error);
        }
    },
}

export default dailyDatafeed;